@if (shouldShow()) {
  <div [id]="htmlId()" class="section-end-wrapper" [style.display]="isVisible() ? 'block' : 'none'">
    <span class="section-end">Sektionsende</span>
  </div>
}
